import { Button, Modal, Input, Select, DatePicker, InputNumber, notification } from "antd";
import { useState } from "react";
import NetworkService from "../services/NetworkService";
import SweetAlert from "react-bootstrap-sweetalert";
import { useAtom } from "jotai";
import { accessTokenAtom } from "../atoms";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import BulkUploadModal from "../components/BulkUploadModal";

const ActiveSGRECModal = ({ currentTabTitle, ccTypes = { categories: [], id: null } }) => {
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [typeofCC, setTypeofCC] = useState();
  const [vintage, setVintage] = useState();
  const [projectLocation, setprojectLocation] = useState();
  const [projectName, setProjectName] = useState("");
  const [projectSerialNo, setprojectSerialNo] = useState("");
  const [projectLink, setprojectLink] = useState();
  const [projectCost, setprojectCost] = useState();
  const [totalQuantity, settotalQuantity] = useState();
  const [availableQuantity, setavailableQuantity] = useState();
  const [inputModal, setInputModal] = useState(false);
  const [ccType, setCCType] = useState([...ccTypes.categories]);
  const [ccError, setccError] = useState();
  const [vintageError, setvintageError] = useState();
  const [projectLocationError, setprojectLocationError] = useState();
  const [projectNameError, setprojectNameError] = useState();
  const [projectSerialError, setprojectSerialError] = useState();
  const [projectLinkError, setprojectLinkError] = useState();
  const [projectCostError, setprojectCostError] = useState();
  const [totalQuantityError, settotalQuantityError] = useState();
  const [api, contextHolder] = notification.useNotification();
  const { instance, accounts } = useMsal();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${day}-${month}-${year}`;

  const toISOLocal = (d) => {
    var z = (n) => ("0" + n).slice(-2);
    var zz = (n) => ("00" + n).slice(-3);
    var off = d.getTimezoneOffset();
    var sign = off > 0 ? "-" : "+";
    off = Math.abs(off);

    return (
      d.getFullYear() +
      "-" +
      z(d.getMonth() + 1) +
      "-" +
      z(d.getDate()) +
      "T" +
      z(d.getHours()) +
      ":" +
      z(d.getMinutes()) +
      ":" +
      z(d.getSeconds()) +
      "." +
      zz(d.getMilliseconds()) +
      "Z"
    );
  };

  const handleCCTypeChange = (value) => {
    if (value !== "NEW_ITEM") {
      setTypeofCC(value);
    } else {
      setInputModal(true);
    }
  };

  const openNotification = () => {
    api.success({
      message: `Added Successfully`,
      description: "Active SG REC Project Added Successfully",
      placement: "top",
      duration: 1,
      onClose: () => {
        window.location.reload(false);
      },
    });
  };
  const inputValidations = () => {
    if (projectName == null || projectName == undefined) {
      setprojectNameError(true);
    } else {
      setprojectNameError(false);
    }

    if (projectLocation == null || projectLocation == undefined) {
      setprojectLocationError(true);
    } else {
      setprojectLocationError(false);
    }

    if (projectSerialNo == null || projectSerialNo == undefined) {
      setprojectSerialError(true);
    } else {
      setprojectSerialError(false);
    }

    if (projectLink == null || projectLink == undefined || projectLink == "") {
      setprojectLinkError(true);
    } else {
      setprojectLinkError(false);
    }

    if (projectCost == null || projectCost == undefined) {
      setprojectCostError(true);
    } else {
      setprojectCostError(false);
    }

    if (totalQuantity == null || totalQuantity == undefined) {
      settotalQuantityError(true);
    } else {
      settotalQuantityError(false);
    }

    if (typeofCC == null || typeofCC == undefined) {
      setccError(true);
    } else {
      setccError(false);
    }

    if (vintage == null || vintage == undefined) {
      setvintageError(true);
    } else {
      setvintageError(false);
    }

    setTimeout(() => {
      if (
        ccError === false &&
        vintageError === false &&
        projectLocationError === false &&
        projectNameError === false &&
        projectNameError === false &&
        projectSerialError === false &&
        projectLinkError === false &&
        projectCostError === false &&
        totalQuantityError === false
      )
        handleOk();
    }, 1000);
  };

  const addNewCC = (ccList) => {
    let inputBody = {
      id: ccTypes.id,
      typeOfGreenInstrument: "SGREC",
      categories: ccList.toString(),
      createdDate: toISOLocal(new Date()),
      createdBy: accounts[0].name,
      modifiedDate: toISOLocal(new Date()),
      modifiedBy: accounts[0].name,
    };
    const networkServiceObj = new NetworkService();
    networkServiceObj.updateCCTypeService(inputBody, accessAtom).then((res) => {});
  };

  const vintageValidation = (e) => {
    setVintage(e);
    if (/^\d{4}$/.test(e)) {
      setvintageError(false);
    } else {
      setvintageError(true);
    }
  };

  const linkValidation = (e) => {
    setprojectLink(e);
    if (/https?:\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/.test(e)) {
      setprojectLinkError(false);
    } else {
      setprojectLinkError(true);
    }
  };

  const handleOk = () => {
    const requestData = {
      dateCreated: toISOLocal(new Date()),
      category: typeofCC,
      vintage: vintage,
      projectName: projectName,
      projectLocation: projectLocation,
      projectSerialNo: projectSerialNo,
      projectLink: projectLink,
      cost: projectCost,
      availableQuantity: totalQuantity,
      totalQuantity: totalQuantity,
      typeOfGreenInstrument: "SGREC",
      createdDate: toISOLocal(new Date()),
      createdBy: accounts[0].name,
      modifiedDate: toISOLocal(new Date()),
      modifiedBy: accounts[0].name,
    };

    fetch(`${process.env.REACT_APP_API_URL}ActiveProject/AddActiveProject`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAtom}`,
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      })
      .then((response) => {
        if (response.messageCode == 201) {
          openNotification();
        }
      });
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {contextHolder}
      <BulkUploadModal label="Active SGREC" uploadType="SGREC" />

      <Button type="primary" onClick={showModal}>
        Create New
      </Button>
      <Modal
        title={`Create new ${currentTabTitle}`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"50%"}

        footer={[
          <Button key="back" onClick={handleCancel}>
            Return
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={inputValidations}
            disabled={
              ccError === false &&
              projectName.includes("/") === false &&
              projectSerialNo.includes("/") === false &&
              vintageError === false &&
              projectLocationError === false &&
              projectNameError === false &&
              projectNameError === false &&
              projectSerialError === false &&
              projectLinkError === false &&
              projectCostError === false &&
              totalQuantityError === false
                ? false
                : true
            }
          >
            Submit
          </Button>,
        ]}
      >
        <div className="py-4">
          <div className="mb-3 row">
            <label for="datecrtd" className="col-sm-2 col-form-label">
              Date Created
            </label>
            <div className="col-sm-10">
              <Input id="date" disabled={true} value={currentDate} className="w-25" />
            </div>
          </div>

          <div className="mb-3 row">
            <label for="cctype" className="col-sm-2 col-form-label">
              Type of SGREC
            </label>
            <div className="col-sm-10">
              <Select
                onBlur={() =>
                  typeofCC == "" || typeofCC == undefined ? setccError(true) : setccError(false)
                }
                status={
                  ccError === true && (typeofCC == "" || typeofCC == undefined) ? "error" : ""
                }
                className="w-25"
                onChange={(e) => handleCCTypeChange(e)}
                value={typeofCC}
              >
                {ccType.map((item) => {
                  return <Select.Option value={`${item}`}>{item}</Select.Option>;
                })}
                <Select.Option value={"NEW_ITEM"}>+ New Item</Select.Option>
              </Select>
              {ccError === true && (typeofCC == "" || typeofCC == undefined) ? (
                <p style={{ color: "red" }}>SGREC is Required</p>
              ) : null}
            </div>
          </div>

          <div className="mb-3 row">
            <label for="vintage" className="col-sm-2 col-form-label">
              Vintage
            </label>
            <div className="col-sm-10">
              <Input
                onMouseLeave={() =>
                  vintage == "" || vintage == undefined ? null : setvintageError(false)
                }
                onBlur={() =>
                  vintage == "" || vintage == undefined
                    ? setvintageError(true)
                    : setvintageError(false)
                }
                style={{ borderColor: vintageError === true ? "red" : "" }}
                id="vintage"
                onChange={(e) => vintageValidation(e.target.value)}
                className="w-25"
              />
              {(vintage == "" || vintage == undefined) && vintageError === true ? (
                <p style={{ color: "red" }}>Vintage cannot be Empty</p>
              ) : vintageError === true ? (
                <p style={{ color: "red" }}>Invalid Format of Vintage</p>
              ) : null}
            </div>
          </div>
          <div className="mb-3 row">
            <label for="projectname" className="col-sm-2 col-form-label">
              Project Name
            </label>
            <div className="col-sm-10">
              <Input
                id="projectname"
                onMouseLeave={() =>
                  projectName == "" || projectName == undefined ? null : setprojectNameError(false)
                }
                onBlur={() =>
                  projectName == "" || projectName == undefined
                    ? setprojectNameError(true)
                    : setprojectNameError(false)
                }
                style={{
                  borderColor:
                    ((projectName == "" || projectName == undefined) &&
                      projectNameError === true) ||
                    projectName.includes("/")
                      ? "red"
                      : "",
                }}
                onInput={(e) => setProjectName(e.target.value)}
                className="w-100"
              />
              {(projectName == "" || projectName == undefined) && projectNameError === true ? (
                <p style={{ color: "red" }}>Project Name cannot be Empty</p>
              ) : projectName.includes("/") ? (
                <p style={{ color: "red" }}>Project Name cannot include "/"</p>
              ) : null}
            </div>
          </div>

          <div className="mb-3 row">
            <label for="projectloc" className="col-sm-2 col-form-label">
              Project Location
            </label>
            <div className="col-sm-10">
              <Input
                onMouseLeave={() =>
                  projectLocation == "" || projectLocation == undefined
                    ? null
                    : setprojectLocationError(false)
                }
                onBlur={() =>
                  projectLocation == "" || projectLocation == undefined
                    ? setprojectLocationError(true)
                    : setprojectLocationError(false)
                }
                id="projectloc"
                style={{
                  borderColor:
                    (projectLocation == "" || projectLocation == undefined) &&
                    projectLocationError === true
                      ? "red"
                      : "",
                }}
                onInput={(e) => setprojectLocation(e.target.value)}
                className="w-100"
              />
              {(projectLocation == "" || projectLocation == undefined) &&
              projectLocationError === true ? (
                <p style={{ color: "red" }}>Project Location cannot be Empty</p>
              ) : null}
            </div>
          </div>
          <div className="mb-3 row">
            <label for="projectserial" className="col-sm-2 col-form-label">
              Project Serial No.
            </label>
            <div className="col-sm-10">
              <Input
                onMouseLeave={() =>
                  projectSerialNo == "" || projectSerialNo == undefined
                    ? null
                    : setprojectSerialError(false)
                }
                onBlur={() =>
                  projectSerialNo == "" || projectSerialNo == undefined
                    ? setprojectSerialError(true)
                    : setprojectSerialError(false)
                }
                id="projectserial"
                style={{
                  borderColor:
                    ((projectSerialNo == "" || projectSerialNo == undefined) &&
                      projectSerialError === true) ||
                    projectSerialNo.includes("/")
                      ? "red"
                      : "",
                }}
                onInput={(e) => setprojectSerialNo(e.target.value)}
                className="w-100"
              />
              {(projectSerialNo == "" || projectSerialNo == undefined) &&
              projectSerialError === true ? (
                <p style={{ color: "red" }}>Project Serial No. cannot be Empty</p>
              ) : projectSerialNo.includes("/") ? (
                <p style={{ color: "red" }}>Project Serial No. cannot include "/"</p>
              ) : null}
            </div>
          </div>
          <div className="mb-3 row">
            <label for="projectlink" className="col-sm-2 col-form-label">
              Project Link
            </label>
            <div className="col-sm-10">
              <Input
                onMouseLeave={() =>
                  projectLink == "" || projectLink == undefined ? null : setprojectLinkError(false)
                }
                onBlur={() =>
                  projectLink == "" || projectLink == undefined
                    ? setprojectLinkError(true)
                    : setprojectLinkError(false)
                }
                id="projectlink"
                style={{ borderColor: projectLinkError === true ? "red" : "" }}
                onInput={(e) => linkValidation(e.target.value)}
                className="w-100"
              />
              {(projectLink == "" || projectLink == undefined) && projectLinkError === true ? (
                <p style={{ color: "red" }}>Project Link cannot be empty</p>
              ) : projectLinkError === true ? (
                <p style={{ color: "red" }}>Invalid Link</p>
              ) : null}
            </div>
          </div>

          <div className="mb-3 row">
            <label for="cost" className="col-sm-2 col-form-label">
              Cost(S$/kWh)
            </label>
            <div className="col-sm-10">
              <InputNumber
                onMouseLeave={() =>
                  projectCost == "" || projectCost == undefined ? null : setprojectCostError(false)
                }
                onBlur={() =>
                  projectCost == "" || projectCost == undefined
                    ? setprojectCostError(true)
                    : setprojectCostError(false)
                }
                id="cost"
                style={{
                  borderColor:
                    (projectCost == "" || projectCost == undefined) && projectCostError === true
                      ? "red"
                      : "",
                }}
                onChange={(e) => setprojectCost(e.toFixed(5))}
                className="w-25"
                step={0.01}
                precision={5}
              />
              {(projectCost == "" || projectCost == undefined) && projectCostError === true ? (
                <p style={{ color: "red" }}>Project Cost cannot be Empty</p>
              ) : null}
            </div>
          </div>
          <div className="mb-3 row">
            <label for="totalqty" className="col-sm-2 col-form-label">
              Total Quantity
            </label>
            <div className="col-sm-10">
              <InputNumber
                onMouseLeave={() =>
                  totalQuantity == "" || totalQuantity == undefined
                    ? null
                    : settotalQuantityError(false)
                }
                onBlur={() =>
                  totalQuantity == "" || totalQuantity == undefined
                    ? settotalQuantityError(true)
                    : settotalQuantityError(false)
                }
                id="totalqty"
                style={{
                  borderColor:
                    (totalQuantity == "" || totalQuantity == undefined) &&
                    totalQuantityError === true
                      ? "red"
                      : "",
                }}
                onChange={(e) => settotalQuantity(e)}
                className="w-25"
                precision={2}
              />
              {(totalQuantity == "" || totalQuantity == undefined) &&
              totalQuantityError === true ? (
                <p style={{ color: "red" }}>Total Quantity cannot be Empty</p>
              ) : null}
            </div>
          </div>
          <SweetAlert
            show={inputModal}
            title="Add New SGREC"
            text="Enter new SGREC"
            showCancelButton
            type="input"
            inputPlaceholder="Enter SGREC Name"
            animation="slide-from-top"
            validationMsg="Please enter a response!"
            onConfirm={(inputValue) => {
              inputValue = inputValue.trim();
              if (ccType.includes(inputValue)) {
                setInputModal(false);
                setTypeofCC(inputValue);
              } else {
                setInputModal(false);
                setCCType([inputValue, ...ccType]);
                setTypeofCC(inputValue);
                addNewCC([...ccType, inputValue]);
              }
            }}
            onCancel={() => {
              setInputModal(false);
            }}
            onEscapeKey={() => setInputModal(false)}
            onOutsideClick={() => setInputModal(false)}
          />
        </div>
      </Modal>
    </>
  );
};

export default ActiveSGRECModal;
